import getValidFolderPaneWidth from './getValidFolderPaneWidth';
import { default as setFolderPaneWidth } from '../legacyActions/setFolderPaneWidth';
import { setShowFolderPane } from '../actions/setShowFolderPane';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import logFolderPaneState from '../helpers/logFolderPaneState';
import { isFeatureEnabled } from 'owa-feature-flags';
import { initializeDynamicLayout } from './initializeDynamicLayout';

export function initializeMailLayout() {
    /**
     * On init try to validate the folder pane width (NavigationBarWidth)
     */
    let storedFolderPaneWidth = getUserConfiguration().UserOptions.NavigationBarWidth;
    storedFolderPaneWidth = getValidFolderPaneWidth(storedFolderPaneWidth, LayoutChangeSource.Init);

    // Set folder pane width
    setFolderPaneWidth(storedFolderPaneWidth);

    const showFolderPane = !getIsBitSet(ListViewBitFlagsMasks.FolderPaneCollapsed);
    setShowFolderPane(showFolderPane);
    logFolderPaneState(LayoutChangeSource.Init, showFolderPane, showFolderPane);

    if (isFeatureEnabled('tri-dynamicLayout')) {
        initializeDynamicLayout();
    }
}
